import AddNewParkingModalView from "../parkings/addNewParkingModal.html";
import AddNewZoneModalView from "../guests/addNewZone.html";

import _ from 'lodash';


angular.module("events")

    .controller("addNewZoneModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', '$http', 'modalService', '$filter', 'options', '$stateParams', function ($scope, $uibModalInstance, Restangular, $http, modalService, $filter, options, $stateParams) {

        $scope.option = {
            name: "",
            parking_id: undefined
        };

        $scope.only_one = options.only_one;

        if (options.type == 'parking') {
            Restangular.all('EventsParkings').getList({ event_id: $stateParams.id }).then(function (parkings) {
                $scope.selectParkings = parkings;
                if (!$scope.$$phase) $scope.$apply();
            });
        }

        $scope.saveOption = function () {
            $uibModalInstance.close($scope.option);

        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
    .controller("assignParkingMassiveModalCtrl", ['$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', 'options', '$stateParams', 'event', 'logService',
        function ($scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, options, $stateParams, event, logService) {

            $scope.parkingOptions = [{ name: $filter('translate')('events.guests.use_event_config'), value: false }, { name: $filter('translate')('events.guests.use_custom_config'), value: true }]
            $scope.event_allow_parking = event.allow_parking;
            $scope.event_max_vehicles = event.default_vehicle_limit;

            $scope.options = {
                custom_parking_config: false,
                parking_id: 0,
                allow_parking: event.allow_parking,
                max_vehicles: event.default_vehicle_limit
            };

            logService.debug($scope.option)

            Restangular.all('EventsParkings').getList({ event_id: $stateParams.id }).then(function (parkings) {
                $scope.selectParkings = parkings;
                $scope.selectParkings.push({ id: 0, name: $filter('translate')('events.guests.no_parking') })
                if (!$scope.$$phase) $scope.$apply();
            });

            $scope.addNewParking = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewParkingModalView,
                    controller: "addParkingModalCtrl",
                    size: 'lg',
                    resolve: {
                        options: {
                            event_id: $stateParams.id
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (parking) {
                    Restangular.all('EventsParkings').post(parking).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            $scope.selectParkings.push(result);
                            $scope.option.parking_id = result.id;
                        }
                    });
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            $scope.saveOption = function () {
                $uibModalInstance.close($scope.options);
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])

    .controller("assignZoneMassiveModalCtrl", ['$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', 'options', '$stateParams', function ($scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, options, $stateParams) {

        $scope.option = {
            zone: "",
            companions_zone: ""
        };

        Restangular.all('EventsGuests/GetZoneOptions').getList({ event_id: $stateParams.id }).then(function (results) {
            $scope.selectZones = _.map(results, function (zone) { return { id: zone, name: zone } });
            $scope.selectZones.push({ id: -1, name: $filter('translate')('events.guests.no_zone') })
            if (!$scope.$$phase) $scope.$apply();
        });

        $scope.addNewZone = function (type) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddNewZoneModalView,
                size: "lg",
                controller: "addNewZoneModalCtrl",
                resolve: {
                    options: {
                        only_one: true
                    }
                }
            });

            //Response del modal
            $modalInstance.result.then(function (option) {
                $scope.selectZones.push({ id: option.name, name: option.name });

                if (type == 'zone') {
                    $scope.option.zone = option.name;
                } else if (type == 'companions_zone') {
                    $scope.option.companions_zone = option.name;
                }

                if (!$scope.$$phase) $scope.$apply();
            });
        }

        $scope.saveOption = function () {
            if ($scope.option.zone == null) $scope.option.zone = "";
            if ($scope.option.companions_zone == null) $scope.option.companions_zone = "";
            $uibModalInstance.close($scope.option);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("assignCompanionsLimitModalCtrl", ['$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', 'options', '$stateParams', 'event', function ($scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, options, $stateParams, event) {

        $scope.isCompanionsAllowed = [
            { name: $filter('translate')('events.guests.isCompanionsLikeEvent'), value: null },
            { name: $filter('translate')('events.staff.yes'), value: true },
            { name: $filter('translate')('events.staff.no'), value: false }
        ];

        $scope.options = {
            max_companions_allowed: 1,
            is_companions_allowed: null,
        };

        $scope.event_allow_companions = !event.is_companions_allowed;
        $scope.event_max_companions = event.default_companions_limit;

        $scope.saveOption = function () {

            if ($scope.options.is_companions_allowed && $scope.options.max_companions_allowed < 1) {
                modalService.message({
                    title: $filter('translate')('events.guests.title_modal_not_order'),
                    message: $filter('translate')('events.min_companions_limit_exception_message'),
                    onAccept: function () {
                    }
                });
            } else {
                $uibModalInstance.close($scope.options);
            }

        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("assignAccreditationMassiveModalCtrl", ['$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', 'options', '$stateParams', 'logService',
        function ($scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, options, $stateParams, logService) {

            $scope.option = {
                event_guest_accreditation_id: undefined
            };
            logService.debug(options);
            //Tipo de acreditación del invitado en el evento
            Restangular.all('EventsGuestsAccreditations').getList({ event_id: options.event_id }).then(function (results) {
                logService.debug(results);
                $scope.selectAccreditions = [{ name: $filter("translate")('events.guests.no_accreditation'), id: 0 }, ...results ];
                if (!$scope.$$phase) $scope.$apply();
            });
            $scope.saveOption = function () {
                $uibModalInstance.close($scope.option);
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])

    .controller("assignActsMassiveModalCtrl", ['event_id', '$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', '$stateParams', function (event_id, $scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, $stateParams) {

        $scope.eventsProgramsActSelected = [];
        //Tipo de acreditación del invitado en el evento
        //Tiene algun acto especifico para marcar a los invitados.
        $http({
            method: 'get',
            url: (window as any).CONFIG.api_url + 'EventsProgramsActs/GetEventEspecificActs',
            params: { event_id: event_id }
        }).then(function (results, status, headers, config) {
            $scope.eventsActs = results.data;
            if ($scope.eventsActs.length > 0) {
                $scope.haveEspecificActs = true;
            }
        });

        $scope.saveOption = function () {
            $uibModalInstance.close($scope.eventsProgramsActSelected);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("assignAnnexesModalCtrl", ['event_id', '$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$http', 'modalService', '$filter', '$stateParams', '$rootScope', function (event_id, $scope, $uibModalInstance, $uibModal, Restangular, $http, modalService, $filter, $stateParams, $rootScope) {

        $scope.eventsAnnexesSelected = [];

        Restangular.all('EventsAnnexes').getList({ event_id: event_id, is_explicit_annex: true }).then(function (response) {
            $scope.annexes = response;
            angular.forEach($scope.annexes, function (row) {
                row.FK_events_programs_annexes_tl_events_programs_annexes = row.FK_events_programs_annexes_tl_events_programs_annexes.find(element => element.language_id == $rootScope.languageId);
            });

            if ($scope.annexes.length > 0) {
                $scope.haveEspecificAnnexes = true;
            }
        });

        $scope.saveOption = function () {
            $uibModalInstance.close($scope.eventsAnnexesSelected);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
    .controller("AddGuestModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'modalService', '$filter', 'logService', 'Restangular', 'params', function (LoginService, $scope, $uibModalInstance, modalService, $filter, logService, Restangular, params) {


        // Comprobamos si tiene permiso escritura
        $scope.genders = [
            { id: 'M', name: $filter("translate")('persons.gender_male') },
            { id: 'F', name: $filter("translate")('persons.gender_female') },
            { id: 'N', name: $filter("translate")('persons.gender_neutral') }
        ];

        $scope.selectedGender = $scope.genders.filter(pt => { return pt.id === 'N' })[0];

        $scope.is_delegate = params.is_delegate;

        $scope.newGuest = {

            event_id: params.event_id,
            referrer_person_id: params.referrer_person_id,
            tag_id: 0,
            accredition_id: 0

        };

        // Tipo de acreditación del invitado en el evento
        Restangular.all('EventsGuestsAccreditations').getList({ event_id: params.event_id }).then(function (results) {
            $scope.accreditationList = results;
            $scope.accreditationList.push({ id: 0, name: $filter('translate')('events.guests.no_accreditation') })
                logService.debug('$scope.accreditationsList: ');
                logService.debug($scope.accreditationsList);
        });

        Restangular.all("Tags").customGET("TagsByEntityType", { entity_type: "persons" }).then(function (result) {
            $scope.tagList = result;
            $scope.tagList.push({ id: 0, title: $filter('translate')('events.guests.no_accreditation') })
        });

        Restangular.all('PersonsTreatments').getList().then(function (result) {

            $scope.treatmentList = result;

            let defaultPersonTreatment = $scope.treatmentList.find(m => { return m.person_default === true });
            let defaultPositionTreatment = $scope.treatmentList.find(m => { return m.position_default === true });

            if (defaultPersonTreatment) $scope.newGuest.person_treatment_id = defaultPersonTreatment.id;
            if (defaultPositionTreatment) $scope.newGuest.position_treatment_id = defaultPositionTreatment.id;

        });

        $scope.createEventGuest = function () {

            // Si es titular o delegado, comprobamos siempre el email porque es obligatior. 
            // Si es solo acompañante, lo comprobamos unicamente si tiene valor
            let requiredEmail = $scope.newGuest.referrer_person_id == null || $scope.is_delegate;

            
            if( requiredEmail || (typeof $scope.newGuest.person_email === "string" && $scope.newGuest.person_email.trim().length > 0)) {
                if (!validateEmail($scope.newGuest.person_email)) {
                    let titleString = $filter('translate')('general.error');
                    let messageString = $filter('translate')('general.invalid_emails_message') + ": " + $scope.newGuest.person_email;

                    return modalService.message({
                        title: titleString,
                        message: messageString,
                        onAccept: function () { }
                    });

                }

            }
            

            $scope.newGuest.gender = $scope.selectedGender.id;
            if ($scope.newGuest.tag_id == 0) $scope.newGuest.tag_id = null;
            if ($scope.newGuest.accredition_id == 0) $scope.newGuest.accredition_id = null; 

            var endpoint = $scope.newGuest.referrer_person_id > 0 ? 'AddNewEventGuestCompanion' : 'AddNewEventGuest'

            Restangular.all('EventsGuests/' + endpoint).post($scope.newGuest).then(function (result) {
                $uibModalInstance.close(result);
            });

        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        let validateEmail = function (valor) {
            let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailPattern.test(valor)) {
                return true;
            } else {
                return false;
            }
        };

    }]);